import { TFunction } from 'i18next'

const LIMIT_VALUES = [25, 50, 100]

export const getLimitOptions = (t: TFunction<['common']>) =>
  LIMIT_VALUES.map((value) => ({
    label: t('common:pagination.rows', { value }),
    value,
  }))

export const DEFAULT_LIMIT = 25
